/**
 * 商品ランキングレイアウトの画像とタイトル・日付のホバーアクションの紐づけ
 *
 * @param {Element} root ルート要素
 */
const rankLinkHover = (root) => {
    /**
     * @type {object} ホバーする要素
     */
    const targets = root.querySelectorAll('.js-productRank__hoverTarget');

    targets.forEach((target) => {
        target.addEventListener('mouseover', () => {
            targets.forEach((_target) => {
                _target.style.opacity = '0.7';
            });
        });

        target.addEventListener('mouseleave', () => {
            targets.forEach((_target) => {
                _target.style.opacity = '1';
            });
        });
    });
};

export default () => {
    const roots = document.querySelectorAll('.js-productRank');

    if (!roots) {
        return;
    }

    roots.forEach((root) => {
        rankLinkHover(root);
    });
};
